
// Bei jQuery Skripten, unbedingt importieren:
import $ from 'jquery';
import Dropzone from "dropzone";

if (document.getElementById('my-dropzone')) {
  let myDropzone = new Dropzone("#my-dropzone");
  myDropzone.on("addedfile", file => {
    console.log(`File added: ${file.name}`);
  });
}

